import {fetchNextApiCall, getCompetitionScorers, getCompetition} from 'app/services/api';
import {catchDataError, checkApiRedirect, RedirectException, parseLinkHeader} from 'app/helpers/apiHelpers';
import {checkCompetitionPathRedirect} from 'app/helpers/actionsHelpers';
import {changeHeaderText} from 'app/actions/headerActions';
import {updateHistory} from 'app/actions/historyActions';
import {updateHttpError} from 'app/components/error/ErrorHandlerActions';

function updateCup(data) {
  return {
    type: 'CUP_SCORERS_META_CUP_UPDATE',
    data,
  };
}

function updateScorers(data) {
  return {
    type: 'CUP_SCORERS_UPDATE',
    data,
  };
}

function errorScorers(data) {
  return {
    type: 'CUP_SCORERS_ERROR',
    data,
  };
}

function fetchingScorers() {
  return {
    type: `CUP_SCORERS_FETCHING`,
  };
}

function setCupHeader(dispatch, cup, seasonSlug) {
  const cupSeasonName = seasonSlug ? `${cup.name} ${cup.season.name}` : cup.name;
  const parent = {
    name: cupSeasonName,
    entity: 'cup',
    slugs: {
      cupSlug: cup.slug,
      seasonSlug: seasonSlug,
    },
  };

  dispatch(
    changeHeaderText({
      title: 'Torjäger',
      parent,
    })
  );
}

function fetchCupScorersSSR(cupSlug, seasonSlug) {
  return function (dispatch, getState) {
    const response1 = getCompetition(cupSlug, seasonSlug)
      .then(response => {
        const cup = response.data;
        checkApiRedirect(cup.slug, cupSlug, cup.season, seasonSlug, getState, cup.active);
        checkCompetitionPathRedirect(cup?.category?.id, getState);
        dispatch(updateHistory('undefined', {store: 'CupScorersPage', data: {metaCup: cup}}));
        setCupHeader(dispatch, cup, seasonSlug);
      })
      .catch(error => {
        if (error instanceof RedirectException) {
          throw error;
        } else {
          const errorData = catchDataError(error);
          dispatch(updateHttpError(errorData));
        }
      });

    const response2 = getCompetitionScorers(cupSlug, seasonSlug)
      .then(response => {
        const meta = parseLinkHeader(response.headers.link);
        const nextUrl = meta.next ? meta.next : null;
        dispatch(
          updateHistory('undefined', {
            store: 'CupScorersPage',
            data: {scorers: response.data, nextUrl, isFetching: false, error: null},
          })
        );
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(
          updateHistory('undefined', {
            store: 'CupScorersPage',
            data: {scorers: [], nextUrl: null, isFetching: false, error: errorData},
          })
        );
      });

    return Promise.all([response1, response2]);
  };
}

function fetchCupScorers(cupSlug, seasonSlug, dispatchRedux, reloading) {
  return function (dispatch, state) {
    let response1;
    if (!reloading) {
      if (state.metaCup && state.scorers.length) {
        setCupHeader(dispatchRedux, state.metaCup, seasonSlug);
        return;
      }
      if (state.error) {
        return;
      }

      response1 = getCompetition(cupSlug, seasonSlug)
        .then(response => {
          const cup = response.data;
          checkApiRedirect(cup.slug, cupSlug, cup.season, seasonSlug, null, cup.active);
          checkCompetitionPathRedirect(cup?.category?.id, null);
          dispatch(updateCup(cup));
          setCupHeader(dispatchRedux, cup, seasonSlug);
        })
        .catch(error => {
          if (error instanceof RedirectException) {
            throw error;
          } else {
            const errorData = catchDataError(error);
            dispatchRedux(updateHttpError(errorData));
          }
        });
    }

    const {isFetching, nextUrl} = state;
    if (isFetching || nextUrl === null) {
      return;
    }
    const fetchFunc = nextUrl ? fetchNextApiCall(nextUrl) : getCompetitionScorers(cupSlug, seasonSlug);
    dispatch(fetchingScorers());
    const response2 = fetchFunc
      .then(response => {
        const meta = parseLinkHeader(response.headers.link);
        const nextUrl = meta.next ? meta.next : null;
        dispatch(updateScorers({scorers: response.data, nextUrl}));
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(errorScorers(errorData));
      });

    return Promise.all([response1, response2]);
  };
}

export {fetchCupScorers, fetchCupScorersSSR};
